import React, { useState, useEffect } from "react";
import {
  Table,
  Empty,
  Popconfirm,
  Row,
  Drawer,
  Col,
  Modal,
  Divider,
} from "antd";
import BkmBankInfoAddForm from "../Forms/BkmBankInfoAddForm";
import BkmBankInfoUpdateForm from "../Forms/BkmBankInfoUpdateForm";

import {
  CloseOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import moment from "moment";

const permissionNames = {
  "01": "Temel Hesap Bilgisi",
  "02": "Ayrıntılı Hesap Bilgisi",
  "03": "Bakiye Bilgisi",
  "04": "Temel Hesap Hareketleri Bilgisi",
  "05": "Ayrıntılı Hesap Hareketleri Bilgisi",
  "07": "Temel Kart Bilgisi",
  "08": "Detaylı Kart Bilgisi",
  "09": "Ayrıntılı Kart İşlem Bilgisi",
};

const BankInfo = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
  });
  const [canceledConsentsChecked, setCanceledConsentsChecked] = useState(false);

  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [detailModal, setDetailModal] = useState({ visible: false });

  useEffect(() => {
    checkCanceledConsentsAsync();
  }, []);

  useEffect(() => {
    if (!canceledConsentsChecked) return;

    getTableData();
  }, [tableDataQueryOptions, canceledConsentsChecked]);

  useEffect(() => {
    if (props.addButtonEvent > 0) {
      setAddFormVisibility(true);
    }
  }, [props.addButtonEvent]);

  useEffect(() => {
    if (!props.bkmConsentResult) return;

    getDetailModalData(
      props.bkmConsentResult.bankInfoId,
      props.bkmConsentResult,
    );
  }, [props.bkmConsentResult]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(`/BkmBankInfo`).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const checkCanceledConsentsAsync = () => {
    RequestHandler.post(
      `/BkmBankInfo/CheckCanceledConsentsAsync`,
      undefined,
      false,
    ).then((response) => {
      setCanceledConsentsChecked(true);
    });
  };

  const getUpdateFormData = (id) => {
    RequestHandler.get(`/BkmBankInfo/GetById/${id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const getDetailModalData = (id, bkmConsentResult) => {
    RequestHandler.get(`/BkmBankInfo/GetById/${id}`).then((response) => {
      if (response) {
        setDetailModal({
          ...response,
          bkmConsentResult: bkmConsentResult,
          visible: true,
        });
      }
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/BkmBankInfo/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const getIdentityType = (type) => {
    const identityTypes = {
      V: "Vergi No",
      K: "T.C. Kimlik No",
      M: "Müşteri No",
      Y: "Yabancı Kimlik No",
      P: "Pasaport No",
    };

    return identityTypes[type];
  };

  const columns = [
    {
      title: "Hesap Sağlayıcı",
      dataIndex: "bankLogo",
      render: (data) => <img style={{ width: 120 }} src={data}></img>,
    },
    {
      title: "Rıza Geçerlilik Tarihi",
      dataIndex: "accessValidityDate",
      render: (data) => moment(data).format("DD.MM.YYYY"),
    },
    // {
    //   title: "Rıza Durumu",
    //   render: (row) => {

    //     const status = {
    //       "B": "Yetki Bekleniyor",
    //       "Y": "Yetkilendirildi",
    //       "K": "Yetki Kullanıldı",
    //       "E": "Yetki ödeme emrine dönüştü",
    //       "S": "Yetki Sonlandırıldı",
    //       "I": "Yetki İptal"
    //     };

    //     const cancelStatus = {
    //       "01": "Yeni Rıza Talebi ile İptal",
    //       "02": "Kullanıcı İsteği ile HHS üzerinden İptal",
    //       "03": "Kullanıcı İsteği ile YÖS üzerinden İptal",
    //       "04": "Süre Aşımı: Yetki Bekleniyor",
    //       "05": "Süre Aşımı: Yetkilendirildi",
    //       "06": "Süre Aşımı: Yetki Ödemeye Dönüşmedi",
    //       "07": "GKD iptali: Aynı rıza no ile mükerrer çağrımı",
    //       "08": "GKD iptali: Rızano ile TCKN uyuşmaması",
    //       "09": "GKD iptali: Uygun ürünü bulunmuyor",
    //       "10": "GKD iptali: HHS Açık Bankacılık kanalı işleme kapalı",
    //       "11": "GKD iptali: Hesap Yetki Sorunu",
    //       "12": "GKD iptali: ÖHK HHS kontrollerini aşamadı",
    //       "13": "GKD iptali: ÖHK isteği ile GKD’den vazgeçildi",
    //       "14": "GKD iptali: Fraud Şüphesi",
    //       "99": "GKD iptali: Diğer"
    //     };

    //     return row.consentStatus === "I" ? cancelStatus[row.consentCancelDetailCode] : status[row.consentStatus];
    //   },
    // },

    {
      title: "Detay",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <a onClick={() => getDetailModalData(data)}>
          <InfoCircleOutlined style={{ fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Güncelle",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <a onClick={() => getUpdateFormData(data)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "İptal",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <Popconfirm
          title="İptal etmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <CloseOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const width = window.innerWidth;
  const breakpoint = 480;
  const textRightClass = width < breakpoint ? "" : "gx-text-right";

  return (
    <>
      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addDrawer"
        title="Rıza Talebi"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <BkmBankInfoAddForm onSuccess={onAddFormSuccess} />
      </Drawer>

      <Drawer
        id="updateDrawer"
        title="Rıza Güncelleme"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <BkmBankInfoUpdateForm
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
        />
      </Drawer>

      <Modal
        id="detailModal"
        title={`${detailModal.bankName} Rıza Bilgisi`}
        visible={detailModal.visible}
        onCancel={() => {
          setDetailModal({ visible: false });
        }}
        width={1000}
        footer={null}
      >
        <Divider>İzin Bilgileri</Divider>
        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            Rıza No :{" "}
          </Col>
          <Col xs={24} lg={16}>
            {detailModal.consentId}
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            Rıza Geçerlilik Tarihi :{" "}
          </Col>
          <Col xs={24} lg={16}>
            {moment(detailModal.accessValidityDate).format("DD.MM.YYYY")}
          </Col>
        </Row>

        {(detailModal.permissions?.includes("04") ||
          detailModal.permissions?.includes("05")) && (
          <>
            <Row>
              <Col
                xs={24}
                lg={8}
                className={`${textRightClass} gx-font-weight-semi-bold`}
              >
                İşlem Sorgu Başlangıç Tarihi :{" "}
              </Col>
              <Col xs={24} lg={16}>
                {moment(detailModal.queryStartDate).format("DD.MM.YYYY")}
              </Col>
            </Row>
            <Row>
              <Col
                xs={24}
                lg={8}
                className={`${textRightClass} gx-font-weight-semi-bold`}
              >
                İşlem Sorgu Bitiş Tarihi :{" "}
              </Col>
              <Col xs={24} lg={16}>
                {moment(detailModal.queryEndDate).format("DD.MM.YYYY")}
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            İzin Türü :{" "}
          </Col>
          <Col xs={24} lg={16}>
            <ul>
              {detailModal.permissions?.map((x) => (
                <li key={x}>{permissionNames[x] || x}</li>
              ))}
            </ul>
          </Col>
        </Row>

        <Divider>Kimlik Bilgileri</Divider>
        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            Müşteri Türü :{" "}
          </Col>
          <Col xs={24} lg={16}>
            {detailModal.customerType === "K" ? "Kurumsal" : "Bireysel"}
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            Kimlik Türü :{" "}
          </Col>
          <Col xs={24} lg={16}>
            {getIdentityType(detailModal.identityType)}
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            lg={8}
            className={`${textRightClass} gx-font-weight-semi-bold`}
          >
            Kimlik No :{" "}
          </Col>
          <Col xs={24} lg={16}>
            {detailModal.identityValue}
          </Col>
        </Row>

        {detailModal.customerType === "K" && (
          <>
            <Row>
              <Col
                xs={24}
                lg={8}
                className={`${textRightClass} gx-font-weight-semi-bold`}
              >
                Kurum Kimlik Türü :{" "}
              </Col>
              <Col xs={24} lg={16}>
                {getIdentityType(detailModal.corporateIdentityType)}
              </Col>
            </Row>
            <Row>
              <Col
                xs={24}
                lg={8}
                className={`${textRightClass} gx-font-weight-semi-bold`}
              >
                Kurum Kimlik No :{" "}
              </Col>
              <Col xs={24} lg={16}>
                {detailModal.corporateIdentityValue}
              </Col>
            </Row>
          </>
        )}

        <Divider />

        {detailModal.bkmConsentResult && (
          <p>{detailModal.bkmConsentResult.message}</p>
        )}

        <p>
          <strong>Not: </strong>Rıza Geçerlilik Süresi dolduğunda hesap
          bilgileriniz güncellenemeyecektir. Güncel bilgileri görüntülemeye
          devam edebilmek, görüntülemek istediğiniz hesap bilgisini güncellemek
          veya rıza süresini uzatmak için ilgili rıza için iptal butonuna basıp,
          tekrar rıza talebinde bulunmanız yada rıza güncelleme işlemi yapmanız
          gerekmektedir.
        </p>
      </Modal>
    </>
  );
};

export default BankInfo;
